export const ICON_TYPES = [
  "archive",
  "close",
  "leave",
  "report",
  "conversation-bubbles",
  "message",
];
